import React from 'react';
import { Button } from 'react-bootstrap';
import { useRMDispatch } from 'redux/hooks';
import AllHitsIcon from 'Icons/Exp_Sidebar/AllHitsIcon.png';
import AnyHitIcon from 'Icons/Exp_Sidebar/AnyHitIcon.png';
import { useSelectedHitButton } from 'redux/hooks/header';
import { ESelectedHitButton, setHitButton } from 'redux/reducers/headerReducer';

export const HitsButtons = () => {
  const selectedHitButton = useSelectedHitButton();
  const dispatch = useRMDispatch();

  const handleHit = (hitType: ESelectedHitButton) => {
    if (selectedHitButton === hitType) {
      dispatch(setHitButton(ESelectedHitButton.None));
      return;
    } else {
      dispatch(setHitButton(hitType));
    }
  };

  const handleAnyHit = () => handleHit(ESelectedHitButton.AnyHits);
  const handleAllHits = () => handleHit(ESelectedHitButton.AllHits);

  return (
    <>
      <div
        id="searchandfilter-score-hitsbutton-wrapper"
        className="scoring-tool-first-row"
      >
        <div
          id="searchandfilter-score-hitsbutton-filterscore-title"
          className="filter-score-text center-align-both-axis"
        >
          Filter Score
        </div>

        <Button
          id="searchandfilter-score-hitsbutton-filterscore-anyhit-button"
          className="scoring-hit-button"
          style={{
            backgroundColor:
              selectedHitButton === ESelectedHitButton.AnyHits ? '#D3D3D3' : '#FFFFFF',
            borderColor: '#BDBDBD',
            color: '#000000',
          }}
          onClick={handleAnyHit}
        >
          <img
            id="searchandfilter-score-hitsbutton-filterscore-anyhit-icon"
            className="hits-icons"
            src={AnyHitIcon}
          />
          Any Hit
        </Button>

        <Button
          id="searchandfilter-score-hitsbutton-filterscore-allhit-button"
          className="scoring-hit-button"
          style={{
            backgroundColor:
              selectedHitButton === ESelectedHitButton.AllHits ? '#D3D3D3' : '#FFFFFF',
            borderColor: '#BDBDBD',
            color: '#000000',
          }}
          onClick={handleAllHits}
        >
          <img
            id="searchandfilter-score-hitsbutton-filterscore-allhit-icon"
            className="hits-icons"
            src={AllHitsIcon}
          />
          All Hits
        </Button>
      </div>
    </>
  );
};
